module.exports = __webpack_public_path__ + "static/media/checked.b9bc4efe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkbox/checked.svg
// module id = 1509
// module chunks = 0